export default __webpack_public_path__ + "static/4-10a12ec96e0339a84b4f79b16479dfe6.jpeg";